export default function ShippingBox({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 3"
      viewBox="0 0 64 64"
      {...props}
    >
      <circle cx="17" cy="17" r="15" fill="#78a0d4" />
      <path
        fill="#93bee5"
        d="M17 2a14.9 14.9 0 0 0-8.99 3.01A14.98 14.98 0 0 0 29 26 14.98 14.98 0 0 0 17 2z"
      />
      <path fill="#976947" d="M22 54V24h34v30" />
      <path fill="#c18e59" d="M22 24h34v30h-4a30 30 0 0 1-30-30z" />
      <rect width="60" height="8" x="2" y="54" fill="#474747" rx="4" />
      <circle cx="53" cy="58" r="4" fill="#939393" />
      <path
        fill="#ccc"
        d="M53 54a4 4 0 0 0-3.32 1.77 6.04 6.04 0 0 0 5.93 4.88l.38-.02A3.98 3.98 0 0 0 53 54z"
      />
      <circle cx="39" cy="58" r="4" fill="#939393" />
      <path
        fill="#ccc"
        d="M39 54a4 4 0 0 0-3.32 1.77 6.04 6.04 0 0 0 5.93 4.88l.38-.02A3.98 3.98 0 0 0 39 54z"
      />
      <circle cx="25" cy="58" r="4" fill="#939393" />
      <path
        fill="#ccc"
        d="M25 54a4 4 0 0 0-3.32 1.77 6.04 6.04 0 0 0 5.93 4.88l.38-.02A3.98 3.98 0 0 0 25 54z"
      />
      <circle cx="11" cy="58" r="4" fill="#939393" />
      <path
        fill="#ccc"
        d="M11 54a4 4 0 0 0-3.32 1.77 6.04 6.04 0 0 0 5.93 4.88l.38-.02A3.98 3.98 0 0 0 11 54z"
      />
      <g fill="#474747">
        <path d="M10 57h2v2h-2zM24 57h2v2h-2zM38 57h2v2h-2zM52 57h2v2h-2z" />
      </g>
      <path fill="#f6b940" d="M35 24v16l4-4 4 4V24" />
      <path fill="#ccc" d="M5 45h14v2H5zM9 49h10v2H9z" />
      <path fill="#f2f2f2" d="m11 16 3 3 8-8 3 3-11 11-6-6z" />
      <path d="M5 45h14v2H5zM9 49h10v2H9zM25.7 13.3l-3-3a1 1 0 0 0-1.4 0L14 17.58l-2.3-2.3a1 1 0 0 0-1.4 0l-3 3a1 1 0 0 0 0 1.42l6 6a1 1 0 0 0 1.4 0l11-11a1 1 0 0 0 0-1.42zM14 23.58 9.41 19 11 17.41l2.3 2.3a1 1 0 0 0 1.4 0l7.3-7.3L23.59 14z" />
      <path d="M58 53h-1V24a1 1 0 0 0-1-1H31.83A15.98 15.98 0 1 0 21 32.5V53H6a5 5 0 0 0 0 10h52a5 5 0 0 0 0-10zm-2 5a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM8 58a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6.97-3h6.06a4.9 4.9 0 0 0 0 6h-6.06a4.9 4.9 0 0 0 0-6zM22 58a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6.97-3h6.06a4.9 4.9 0 0 0 0 6h-6.06a4.9 4.9 0 0 0 0-6zM36 58a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm6.97-3h6.06a4.9 4.9 0 0 0 0 6h-6.06a4.9 4.9 0 0 0 0-6zM36 25h6v12.59l-2.3-2.3a1 1 0 0 0-1.4 0L36 37.6zm-19 6a14.06 14.06 0 1 1 12.63-8H22a1 1 0 0 0-1 1v6.4a14 14 0 0 1-4 .6zm6-6h11v15a1 1 0 0 0 1.7.7l3.3-3.29 3.3 3.3a1 1 0 0 0 .7.29.99.99 0 0 0 .38-.08A1 1 0 0 0 44 40V25h11v28H23zM3 58a3 3 0 0 1 3-3h1.03a4.9 4.9 0 0 0 0 6H6a3 3 0 0 1-3-3zm55 3h-1.03a4.9 4.9 0 0 0 0-6H58a3 3 0 0 1 0 6z" />
      <path d="M10 57h2v2h-2zM24 57h2v2h-2zM38 57h2v2h-2zM52 57h2v2h-2z" />
    </svg>
  );
}
